import Flickity from 'flickity';

import flickitySmoothScrolling from '../globals/flickity-smooth-scrolling';
import {register} from '../vendor/theme-scripts/theme-sections';

const sections = {};

const selectors = {
  slider: '[data-slider]',
  sliderItem: '[data-slider-item]',
};

class LogoList {
  constructor(section) {
    this.container = section.container;
    this.slider = this.container.querySelector(selectors.slider);
    this.sliderResizeEvent = () => this.checkSlides();
    this.flkty = null;
    this.checkSlides();

    document.addEventListener('theme:resize:width', this.sliderResizeEvent);
  }

  checkSlides() {
    const containerWidth = this.container.offsetWidth;
    let slidesTotalWidth = this.getSlidesWidth();

    if (window.innerWidth >= theme.sizes.small && slidesTotalWidth > containerWidth) {
      this.initSlider();
    } else {
      this.destroySlider();
    }
  }

  getSlidesWidth() {
    let slidesTotalWidth = 0;
    const slides = this.container.querySelectorAll(selectors.sliderItem);

    if (slides.length) {
      slides.forEach((slide) => {
        slidesTotalWidth += slide.offsetWidth;
      });
    }
    return slidesTotalWidth;
  }

  initSlider() {
    const flkty = Flickity.data(this.slider);

    if (flkty !== null) {
      this.flkty = new Flickity(this.slider, {
        contain: true,
        wrapAround: true,
        pageDots: false,
      });

      // iOS smooth scrolling fix
      flickitySmoothScrolling(this.slider);
    }
  }

  destroySlider() {
    const flkty = Flickity.data(this.slider);

    if (flkty) {
      this.flkty.destroy();
    }
  }

  onBlockSelect(evt) {
    const index = parseInt([...evt.target.parentNode.children].indexOf(evt.target));

    if (this.flkty !== null) {
      this.flkty.select(index);
    } else {
      const sliderStyle = this.slider.currentStyle || window.getComputedStyle(this.slider);
      const sliderPadding = parseInt(sliderStyle.paddingLeft);
      const blockPositionLeft = evt.target.offsetLeft - sliderPadding;

      this.slider.scrollTo({
        top: 0,
        left: blockPositionLeft,
        behavior: 'smooth',
      });
    }
  }

  onUnload() {
    const flkty = Flickity.data(this.slider);

    if (flkty) {
      this.flkty.destroy();
    }
    document.removeEventListener('theme:resize:width', this.sliderResizeEvent);
  }
}

const LogoListSection = {
  onLoad() {
    sections[this.id] = new LogoList(this);
  },
  onUnload(e) {
    sections[this.id].onUnload(e);
  },
  onBlockSelect(e) {
    sections[this.id].onBlockSelect(e);
  },
};

register('logo-list', LogoListSection);
